// extracted by mini-css-extract-plugin
module.exports = {"signInTooltip":"SignInTooltip_signInTooltip__typ6v","icon":"SignInTooltip_icon__v0H84","message":"SignInTooltip_message__7gK3w"};